import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import art from '../../../../static/js/proto/art/Art.js';

/**
 * 数字键盘
 */
@Component({

})
export default class NumKeyboard extends Vue {
  @Prop({ default: '' })
  public value;
  @Prop()
  public boardPrice;
  @Prop()
  public title;
  @Prop()
  public exclude: Node | Node[] | ((current: Node) => boolean);
  @Prop({ default: false })
  public isInteger: boolean;
  @Prop({ default: true })
  public showPriceType: boolean;
  // @Prop({ default: 1 })
  // public priceTickss;
  // 中介
  public price: any = '';

  public get priceT() {
    return this.$store.state.priceTick.priceTick;
  }
  /**控制价格是否清空 */
  public get priceFlage() {
    return this.$store.state.keyBoard.priceFlage;
  }
  public priceTickss: any = '';
  public decimalsBoolean: boolean = false;
  public decimals: any = '';

  @Watch('priceT', { deep: true })
  public changePrice(tick, old) {
    this.priceTickss = tick;
    this.decimals = art.digit(this.priceTickss);
    if (this.decimals === 0) {
      this.decimalsBoolean = true;
    } else {
      this.decimalsBoolean = false;
    }
  }
  @Watch('boardPrice', {deep: true})
  public selectPriceType(news, old) {
    this.price = news;
  }
  @Watch('value', { deep: true })
  public inputPrice(news, old) {
    this.price = news;
  }
  public setValue(v: number | string) {
    if (typeof v === 'number') {
      v = v.toFixed(this.decimals);
      // v = v.replace(/\.?0+$/, '');
    }
    if (this.isInteger) {
      v = v.replace(/\..*/, '');
    }
    this.$emit('input', v);
  }
  public getValue() {
    if (Number(this.price)) {
      return this.price + '';
    } else {
      return '0';
    }
  }

  public mounted() {
    this.price = this.value;
    this.priceTickss = this.priceT;
    this.decimals = art.digit(this.priceTickss);
    if (this.decimals === 0) {
      this.decimalsBoolean = true;
    } else {
      this.decimalsBoolean = false;
    }
  }
  public handleClose() {
    this.$emit('close');
  }
  public handleClick(targetId) {
    this.$emit('submit', targetId);
    this.$emit('close');
  }
  // 处理按键
  public orderInput(num) {
    switch (String(num)) {
      // 小数点
      case '.':
        this._handleDecimalPoint();
        break;
      case 'add':
        this._handleAddKey();
        break;
      case 'reduce':
        this._handleReduceKey();
        break;
      case 'delete':
        this._handleDeleteKey();
        break;
      default:
        this._handleNumberKey(num);
        break;
    }
  }
  // 处理小数点函数
  public _handleDecimalPoint() {
    let value = this.getValue();
    if (this.decimalsBoolean) {
      return;
    }
    // 如果包含小数点，直接返回
    if (value.indexOf('.') > -1) {
      return false;
    }
    // 如果小数点是第一位，补0
    if (!value.length) {

      value = '0.';
    } else {
      // 如果不是，添加一个小数点
      value = value + '.';
    }
    this.setValue(value);
  }
  public _handleAddKey() {
    // 否则删除最后一个
    this.priceTickss = this.priceTickss ? this.priceTickss : 1;
    let value = 0;
    if (!this.isInteger) {
      if (parseFloat(this.getValue())) {
        value = parseFloat(this.getValue()) + Number(this.priceTickss);
        if (isNaN(value)) {
          value = 1;
        }
      } else {
        value =
          Number(this.boardPrice) + Number(this.priceTickss);
      }
    } else {
      if (!this.value && Number(this.value) !== 0) {
        value = 1;
      } else {
        if (parseFloat(this.getValue()) || parseFloat(this.getValue()) === 0) {
          value = parseFloat(this.getValue()) + 1;
        } else {
          value = Number(this.boardPrice) + 1;
        }
      }
    }
    this.setValue(value);
  }
  public _handleReduceKey() {
    // 否则删除最后一个
    this.priceTickss = this.priceTickss ? this.priceTickss : 1;
    let value = 0;
    if (!this.isInteger) {
      value = parseFloat(this.getValue()) ?
        parseFloat(this.getValue()) - Number(this.priceTickss) :
        Number(this.boardPrice) - Number(this.priceTickss);
    } else {
      value = parseFloat(this.getValue()) ?
        parseFloat(this.getValue()) - 1 :
        Number(this.boardPrice) - 1;
      // if (isNaN(value)) {
      //   value = 0;
      // }
      // if (value < 0) {
      //   value = 0;
      // }
      // this.setValue(value);
    }
    if (isNaN(value)) {
      value = 0;
    }
    if (value < 0) {
      value = 0;
    }
    this.setValue(value);
  }
  // 处理删除键
  public _handleDeleteKey() {
    if (!this.value) {
      return;
    }
    const S = this.getValue();
    // 如果没有输入，直接返回
    if (!S.length) {
      return false;
    }
    // 否则删除最后一个
    const value = S.substring(0, S.length - 1);
    this.setValue(value);
  }
  // 处理清空键
  public _handleClearKey() {
    this.setValue('');
  }
  // 处理数字
  public _handleNumberKey(num) {
    const S = this.getValue();
    let value = S;
    // 如果有小数点且小数点位数不小于2
    // tslint:disable-next-line:max-line-length
    if (S.indexOf('.') > -1 && S.substring(S.indexOf('.') + 1).length < this.decimals) {

      value = S + num;
    }
    // 没有小数点
    if ((S.indexOf('.') === -1)) {
      // tslint:disable-next-line:triple-equals
      if (num == 0 && S.length == 0) {
        value = '';
      } else {
        value = S.replace(/^0+/, '') + num;
      }
    }
    if (value.length > 13) {
      value = value.slice(0, 13);
    }
    if (!this.priceFlage) {
      value = num + '';
      this.$store.commit('keyBoard/changePriceFlage', true);
    }
    this.setValue(value);
  }
  // 提交
  public _handleConfirmKey() {
    this.$emit('close');
    let S = this.getValue();
    // 未输入
    if (!S.length) {
      return false;
    }
    // 将 8. 这种转换成 8.00
    if (S.indexOf('.') > -1 && S.indexOf('.') === (S.length - 1)) {

      S = Number(S.substring(0, S.length - 1)).toFixed(this.decimals);
    }
    // 保留两位
    S = Number(S).toFixed(this.decimals);
    this.setValue(S);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NumKeyboard/NumKeyboard.ts